import PermissionTooltip from '@components/PermissionTooltip';
import { CustomDateField } from '../styles/common';
import { FormLabel } from '../Label/form-label';

export function PermissionFormField({
  layoutClass,
  hideLabel,
  item,
  hidden,
  disabled,
  error,
  children,
  fieldClass = '',
}) {
  return (
    <div
      className={
        layoutClass
          ? `${layoutClass} sk:my-2!`
          : `${hideLabel ? 'sk:w-full sk:flex-none sk:px-4' : 'sk:w-3/12 sk:flex-none sk:px-4'} sk:my-2!`
      }
      key={item.name}
    >
      <CustomDateField
        className={fieldClass}
        error={!!error}
        required={item.required && !hideLabel}
      >
        {!hideLabel && (
          <FormLabel label={item.label} info_tooltip={item.info_tooltip} />
        )}
        <PermissionTooltip
          disabled={disabled}
          hidden={hidden}
          position="bottom left"
        >
          {children}
        </PermissionTooltip>
      </CustomDateField>
    </div>
  );
}
